import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
@import url('https:/./fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap');

  @font-face {
      font-family: "Galano Grotesque Alt";
      font-weight: normal;
      font-style: normal;
      src: url("/bradescoexclusive/fonts/galano-grotesque-alt-bold.otf") format("opentype");
      src: url("/bradescoexclusive/fonts/galano-grotesque-alt-bold.woff2") format("woff2");
      src: url("/bradescoexclusive/fonts/galano-grotesque-alt-bold.ttf") format("eot");
      src: url("/bradescoexclusive/fonts/galano-grotesque-alt-bold.eot") format("truetype");
      src: url("/bradescoexclusive/fonts/galano-grotesque-alt-bold.woff") format("woff");
  }

  @font-face {
      font-family: 'Open Sans';
      font-weight: normal;
      font-style: normal;
      src: url('/bradescoexclusive/fonts/OpenSans-Regular-webfont.eot') format("opentype");
      src:
          local('Open Sans'),
          local('OpenSans'),
          url('/bradescoexclusive/fonts/OpenSans-Regular-webfont.eot?#iefix') format('embedded-opentype'),
          url('/bradescoexclusive/fonts/OpenSans-Regular-webfont.woff') format('woff'),
          url('/bradescoexclusive/fonts/OpenSans-Regular-webfont.svg#open_sansregular') format('svg');
  }

  @font-face {
    font-family: 'Work Sans';
    font-weight: 100;
    font-style: normal;
    font-display: swap;
    src: local('Work Sans Thin'),
          url('/bradescoexclusive/fonts/workSans/WorkSans-Thin.woff') format('woff');
  }

  @font-face {
    font-family: 'Work Sans';
    font-weight: 200;
    font-style: normal;
    font-display: swap;
    src: local('Work Sans ExtraLight'),
          url('/bradescoexclusive/fonts/workSans/WorkSans-ExtraLight.woff') format('woff');
  }

  @font-face {
    font-family: 'Work Sans';
    font-weight: 300;
    font-style: normal;
    font-display: swap;
    src: local('Work Sans Light'),
          url('/bradescoexclusive/fonts/workSans/WorkSans-Light.woff') format('woff');
  }

  @font-face {
    font-family: 'Work Sans';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: local('Work Sans Regular'),
          url('/bradescoexclusive/fonts/workSans/WorkSans-Regular.woff') format('woff');
  }

  @font-face {
    font-family: 'Work Sans';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    src: local('Work Sans Medium'),
          url('/bradescoexclusive/fonts/workSans/WorkSans-Medium.woff') format('woff');
  }

  @font-face {
    font-family: 'Work Sans';
    src: local('Work Sans SemiBold'),
          url('/bradescoexclusive/fonts/workSans/WorkSans-SemiBold.woff') format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Work Sans';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: local('Work Sans Bold'),
          url('/bradescoexclusive/fonts/workSans/WorkSans-Bold.woff') format('woff');
  }

  @font-face {
    font-family: 'Work Sans';
    font-weight: 800;
    font-style: normal;
    font-display: swap;
    src: local('Work Sans ExtraBold'),
          url('/bradescoexclusive/fonts/workSans/WorkSans-ExtraBold.woff') format('woff');
  }

  @font-face {
    font-family: 'Work Sans';
    font-weight: 900;
    font-style: normal;
    font-display: swap;
    src: local('Work Sans Black'),
          url('/bradescoexclusive/fonts/workSans/WorkSans-Black.woff') format('woff');
  }

  @font-face {
    font-family: 'Platform Web';
    font-weight: 100;
    font-style: normal;
    font-display: swap;
    src: local('Platform Web'),
          url('/bradescoexclusive/fonts/platform/Platform-Hairline-Web.woff2') format('woff2'),
          url('/bradescoexclusive/fonts/platform/Platform-Hairline-Web.woff') format('woff');
  }

  @font-face {
    font-family: 'Platform Web';
    font-weight: 100;
    font-style: italic;
    font-display: swap;
    src: local('Platform Web'),
          url('/bradescoexclusive/fonts/platform/Platform-HairlineItalic-Web.woff2') format('woff2'),
          url('/bradescoexclusive/fonts/platform/Platform-HairlineItalic-Web.woff') format('woff');
  }

  @font-face {
    font-family: 'Platform Web';
    font-weight: 300;
    font-style: normal;
    font-display: swap;
    src: local('Platform Web'),
          url('/bradescoexclusive/fonts/platform/Platform-Light-Web.woff2') format('woff2'),
          url('/bradescoexclusive/fonts/platform/Platform-Light-Web.woff') format('woff');
  }

  @font-face {
    font-family: 'Platform Web';
    font-weight: 300;
    font-style: italic;
    font-display: swap;
    src: local('Platform Web'),
          url('/bradescoexclusive/fonts/platform/Platform-LightItalic-Web.woff2') format('woff2'),
          url('/bradescoexclusive/fonts/platform/Platform-LightItalic-Web.woff') format('woff');
  }

  @font-face {
    font-family: 'Platform Web';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: local('Platform Web'),
          url('/bradescoexclusive/fonts/platform/Platform-Regular-Web.woff2') format('woff2'),
          url('/bradescoexclusive/fonts/platform/Platform-Regular-Web.woff') format('woff');
  }

  @font-face {
    font-family: 'Platform Web';
    font-weight: 400;
    font-style: italic;
    font-display: swap;
    src: local('Platform Web'),
          url('/bradescoexclusive/fonts/platform/Platform-RegularItalic-Web.woff2') format('woff2'),
          url('/bradescoexclusive/fonts/platform/Platform-RegularItalic-Web.woff') format('woff');
  }

  @font-face {
    font-family: 'Platform Web';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    src: local('Platform Web'),
          url('/bradescoexclusive/fonts/platform/Platform-Medium-Web.woff2') format('woff2'),
          url('/bradescoexclusive/fonts/platform/Platform-Medium-Web.woff') format('woff');
  }

  @font-face {
    font-family: 'Platform Web';
    font-weight: 500;
    font-style: italic;
    font-display: swap;
    src: local('Platform Web'),
          url('/bradescoexclusive/fonts/platform/Platform-MediumItalic-Web.woff2') format('woff2'),
          url('/bradescoexclusive/fonts/platform/Platform-MediumItalic-Web.woff') format('woff');
  }

  @font-face {
    font-family: 'Platform Web';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: local('Platform Web'),
          url('/bradescoexclusive/fonts/platform/Platform-Bold-Web.woff2') format('woff2'),
          url('/bradescoexclusive/fonts/platform/Platform-Bold-Web.woff') format('woff');
  }

  @font-face {
    font-family: 'Platform Web';
    font-weight: 700;
    font-style: italic;
    font-display: swap;
    src: local('Platform Web'),
          url('/bradescoexclusive/fonts/platform/Platform-BoldItalic-Web.woff2') format('woff2'),
          url('/bradescoexclusive/fonts/platform/Platform-BoldItalic-Web.woff') format('woff');
  }


* {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
}

.modal-container p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;    
}

body, html, #root {
	-webkit-font-smoothing: antialiased;
	text-rendering: optimizeLegibility;
}

body {
    font: 400 14px 'Work Sans';
}

input, button {
    font: 400 18px 'Work Sans', sans-serif;
}

button {
    cursor: pointer;
}
.ReactModal__Overlay--after-open {
    z-index: 9999;
}
#plans {
  @media only screen and (max-width: 962px) and (min-width: 601px) {
    background-size: auto;
    background-position: center;
  }
}

#root {
  @media only screen and (max-width: 1024px) and (min-width: 768px) {
  & > div {
    & > div {
      & > div:nth-child(2) {
        & > div:last-of-type {
          padding: 1.5rem 0;
          padding-bottom: 2rem;
        }
      }
    }
  }
  }
 
}
`;

export const borderWidth = {
  none: `0`,
  sm: `1px`,
  md: `2px`,
  lg: `4px`,
  xlg: `8px`,
};

export const borderRadius = {
  none: `0`,
  sm: `4px`,
  md: `8px`,
  lg: `15px`,
  circle: `50%`,
  pill: `9999px`,
};

/**
 * @tokens Colors
 * @presenter Color
 */
export const colorBrandPrimary = {
  turquoise: `#28c4d6`,
  marine: `#24206b`,
  darkMarine: `#100B53`,
};

export const colorBrandSecondary = {
  fuchsia: `#c11f57`,
  anil: `#561dff`,
  lime: `#d6de26`,
  amber: `#ffcc00`,
  purple: `#bd10e0`,
};

export const colorNeutralGrey = {
  10: `#f7f7fc`,
  30: `#e2e1eb`,
  40: `#d4d3dd`,
  50: `#aeabc4`,
};

export const colorNeutralDark = {
  80: `#585380`,
  90: `#110e49`,
};

export const colorNeutral = {
  light: `#ffffff`,
};
/**
 * @tokens Font Family
 * @presenter Font Family
 */
export const fontFamily = {
  brand: `Platform Web`,
  neutral: `Work Sans`,
};

export const fontSize = {
  xxl: `3rem`,
  xl: `2.5rem`,
  lg: `2rem`,
  md: `1.5rem`,
  xxxs: `0.75rem`,
  sm: `1.25rem`,
  xs: `1rem`,
  xxs: `0.875rem`,
};

export const shadow = {
  level1: `0 2px 6px 2px rgba(0, 0, 0, 0.12), 0 0 1px 1px rgba(0, 0, 0, 0.12)`,
  level2: `0 4px 12px 4px rgba(0, 0, 0, 0.12), 0 0 1px 1px rgba(0, 0, 0, 0.12)`,
  level3: `0 8px 24px 8px rgba(0, 0, 0, 0.12), 0 0 1px 1px rgba(0, 0, 0, 0.12)`,
};

export const marginHeight = "26px";

export default GlobalStyle;
